<template>
  <div class="main-container">
    <HeaderComp ref="headerRef"/>
    <MainBlock :header-height="headerHeight"/>
    <AboutUs/>
    <ProjectsBlock/>
    <ExperienceBlock/>
    <TeamBlock/>
    <LetsTalk @open-contact="openContactModal" />
    <FooterBlock/>
    <BottomGradient/>

    <transition name="contact-modal">
      <div
        v-if="isContactOpen"
        class="contact-overlay"
        @click="closeContactModal"
      >
        <div class="contact-modal" @click.stop>
          <h3 class="contact-title">{{ $t('contact.title') }}</h3>
          <p class="contact-subtitle">{{ $t('contact.subtitle') }}</p>

          <form class="contact-form" @submit.prevent="submitContact">
            <label class="contact-field">
              <span>{{ $t('contact.fields.name') }}</span>
              <input v-model="contactForm.name" type="text" />
            </label>

            <label class="contact-field">
              <span>{{ $t('contact.fields.project') }}</span>
              <input v-model="contactForm.project" type="text" />
            </label>

            <label class="contact-field">
              <span>{{ $t('contact.fields.description') }}</span>
              <textarea v-model="contactForm.description" rows="3" />
            </label>

            <label class="contact-field">
              <span>{{ $t('contact.fields.budget') }}</span>
              <input v-model="contactForm.budget" type="text" />
            </label>

            <button type="submit" class="contact-submit">
              {{ $t('contact.submit') }}
            </button>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HeaderComp from './blocks/HeaderComp.vue';
import MainBlock from './blocks/MainBlock.vue';
import AboutUs from './blocks/AboutUs.vue';
import ProjectsBlock from './blocks/ProjectsBlock.vue';
import ExperienceBlock from './blocks/ExperienceBlock.vue';
import TeamBlock from './blocks/TeamBlock.vue';
import LetsTalk from './blocks/LetsTalk.vue';
import FooterBlock from './blocks/FooterBlock.vue';
import BottomGradient from './elements/BottomGradient.vue';
export default {
  name: 'MainPage',
  components: { 
    HeaderComp, 
    MainBlock, 
    AboutUs, 
    ProjectsBlock, 
    ExperienceBlock,
    TeamBlock,
    LetsTalk,
    FooterBlock,
    BottomGradient
  },
  data() {
    return {
      headerHeight: 0,
      isContactOpen: false,
      contactForm: {
        name: '',
        project: '',
        description: '',
        budget: '',
      },
    }
  },
  mounted() {
    this.updateHeaderHeight();
    window.addEventListener('resize', this.updateHeaderHeight);
    
    // Инициализируем Lenis для плавного скролла
    import('lenis').then((Lenis) => {
      const lenis = new Lenis.default({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true,
      });
      
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      
      requestAnimationFrame(raf);
      
      this.lenisInstance = lenis;
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateHeaderHeight);
    if (this.lenisInstance) {
      this.lenisInstance.destroy();
    }
  },
  methods: {
    updateHeaderHeight() {
      if (this.$refs.headerRef) {
        const headerElement = this.$refs.headerRef.$el;
        if (headerElement) {
          this.headerHeight = headerElement.offsetHeight;
        }
      }
    },
    openContactModal() {
      this.isContactOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeContactModal() {
      this.isContactOpen = false;
      document.body.style.overflow = '';
    },
    submitContact() {
      const name = this.contactForm.name || '-';
      const project = this.contactForm.project || '-';
      const description = this.contactForm.description || '-';
      const budget = this.contactForm.budget || '-';

      const message = this.$t('contact.telegramMessage', {
        name,
        project,
        description,
        budget,
      });

      const url = `https://t.me/zeroliquid_manager?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');

      this.closeContactModal();
    },
  }
}
</script>


<style scoped>
  .main-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100vw;
    padding-left: 13%;
    padding-right: 13%;
    box-sizing: border-box;
    max-width: 100vw;
  }

  @media screen and (max-width: 1024px) {
  .main-container {
    padding-left: 10%;
    padding-right: 10%;
    gap: 16px
  }
}

@media screen and (max-width: 768px) {
  .main-container {
    padding-left: 5%;
    padding-right: 5%;
  }
}

.contact-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483000;
}

.contact-modal {
  width: min(480px, 90vw);
  background: rgba(0, 0, 0, 0.9);
  border-radius: 24px;
  padding: 24px 24px 28px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.7);
  z-index: 2147483647;
}

.contact-title {
  margin: 0 0 8px;
  font-size: clamp(20px, 2vw, 28px);
  font-weight: 300;
  text-transform: uppercase;
}

.contact-subtitle {
  margin: 0 0 20px;
  font-size: 13px;
  opacity: 0.6;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.contact-field span {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.7;
  margin-bottom: 4px;
}

.contact-field input,
.contact-field textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.03);
  color: #fff;
  padding: 8px 14px;
  font-family: inherit;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
}

.contact-field textarea {
  border-radius: 8px;
  resize: none;
  min-height: 72px;
}

.contact-field input:focus,
.contact-field textarea:focus {
  border-color: rgba(255, 255, 255, 0.5);
}

.contact-submit {
  margin-top: 10px;
  width: 100%;
  border-radius: 8px;
  border: none;
  padding: 10px 18px;
  background: #fff;
  color: #000;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.contact-submit:hover {
  background: #e5e5e5;
  transform: translateY(-1px);
}

.contact-modal-enter-active,
.contact-modal-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.contact-modal-enter-from,
.contact-modal-leave-to {
  opacity: 0;
  transform: scale(0.96);
}
</style>
